import React, { useState, useEffect, useRef } from "react";
import { fetchJsonAds } from "../../../services/fetchJsonAds";
import "./Feed.css";
import { FeedVerticalBlock } from "./FeedVerticalBlock";
import { FeedHorizontalBlock } from "./FeedHorizontalBlock";
import { fetchJsonAdsCount } from "../../../constants";

const MAX_ATTEMPTS = 3;

// groupSizes — сколько тизеров в чередующихся блоках: первый (с картинкой сверху) и второй (с картинкой слева).
export const Feed = ({ object, isDesktop, userId, showId, initialData = [], utmTerm, groupSizes = [8, 8] }) => {
    const [jsonData, setJsonData] = useState(initialData);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [attempts, setAttempts] = useState(0);
    const [hasInitialData, setHasInitialData] = useState(initialData.length > 0);
    const observerRef = useRef(null);
    const groups = [];
    for (let i = 0, g = 0; i < jsonData.length; g++) {
        const size = groupSizes[g % 2];
        groups.push(jsonData.slice(i, i + size));
        i += size;
    }

    useEffect(() => {
        setJsonData(initialData);
        setHasInitialData(initialData.length > 0);
    }, [initialData]);

    useEffect(() => {
        if (!userId || !showId || attempts >= MAX_ATTEMPTS || hasInitialData) return;
        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetchJsonAds(object, fetchJsonAdsCount, userId, showId, utmTerm);
                const data = response.news;
                if (data && data.length > 0) {
                    setJsonData((prevData) => [...prevData, ...data]);
                    setAttempts(0);
                } else {
                    setAttempts((prev) => prev + 1);
                }
            } catch (error) {
                setAttempts((prev) => prev + 1);
                console.error("Ошибка при загрузке данных:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [object, currentPage, userId, showId, attempts, hasInitialData, utmTerm]);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: "100px",
            threshold: 0.1,
        };

        const observer = new IntersectionObserver((entries) => {
            const [entry] = entries;
            if (entry.isIntersecting && !loading && attempts < MAX_ATTEMPTS) {
                setCurrentPage((prevPage) => prevPage + 1);
                if (hasInitialData) {
                    setHasInitialData(false);
                }
            }
        }, options);

        const currentObserver = observerRef.current;
        if (currentObserver) {
            observer.observe(currentObserver);
        }

        return () => {
            if (currentObserver) {
                observer.unobserve(currentObserver);
            }
        };
    }, [loading, currentPage, attempts, hasInitialData]);

    return (
        <div className="feed-container">
            {groups.slice(0, currentPage).map((items, index) => {
                const isVertical = index % 2 === 0;
                return isVertical ? (
                    <FeedVerticalBlock key={`vertical-${index}`} items={items} objectId={object} showId={showId} />
                ) : (
                    <FeedHorizontalBlock
                        key={`horizontal-${index}`}
                        items={items}
                        isDesktop={isDesktop}
                        objectId={object}
                        showId={showId}
                    />
                );
            })}
            {attempts < MAX_ATTEMPTS && (
                <div ref={observerRef} style={{ height: "20px", width: "100%" }} className="loading-trigger" />
            )}
        </div>
    );
};
